/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-constructor */
import React, { Component } from 'react'
import moment from "moment";
import domtoimage from 'dom-to-image';

import TaContext from './TaContext';
import { CurrencyUtils } from "../../utils";
import OrderService from "../../service/order";
import { DATETHAI_FORMAT, DATETIME_PAYMENT_FORMAT } from "../../const";

import successful from "../../images/checked.svg";

const imgScale = { width: "24px", height: "24px"};
const Icon = (props) => <img className={props.className} src={props.src} {...imgScale} />;

class Step6 extends Component {
  callBackAction;
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    setTimeout(() => {
      this.onSaveImage();
    }, 1000);
  }

  onSaveImage() {
    const { step5: { paymentModel } } = this.context;
    var node = document.getElementById('capture-wrapper');
    var options = {quality: 1};

    domtoimage.toPng(node, options).then((dataUrl) => {
        OrderService.saveReceipt({
          ref_id: paymentModel.orderId,
          receipt: dataUrl
        })
    });
  }

  render() {
    const { step1, step2, step5, step6 = {} } = this.context;
    const { start_date, end_date, counter, provinceFrom, provinceTo, provinceOther } = step1;
    const { paymentModel } = step5;
    const { transaction_datetime } = step6.payment_result || {};
    const { selectedPlan, planList } = step2;
    const planDetail = planList.filter((plan) => plan.id === selectedPlan)[0] || {};
    const { insured, total, product_name, plan_package } = planDetail;
    const totalAmount = counter ? total * counter : total;
    return (
      <div id="capture-wrapper" className="form-wrapper payment-wrapper successful">
        <div className="form-group d-flex flex-column flex-1 w-100">
          <Icon className="align-item-center w-100 payment-icon" src={successful} />
          <div className="form-group">
            <div className="successful-reactagle ">
              <label className="text-center">ชำระเบี้ยประกันเรียบร้อย</label>
              <p className="text-center">
                {moment().format(DATETIME_PAYMENT_FORMAT)}
              </p>
            </div>
          </div>
          <div className="form-wrapper successful-wrapper">
            {/* <div className="form-group"> */}
            <div className="form-group">
              <label className="total-value text-center">{CurrencyUtils.currency(totalAmount)} บาท</label>
            </div>
            <div className="form-group">
              <label className="ref-value text-center mt-0">Reference ID {paymentModel.orderId}</label>
            </div>
            <hr />
            <div className="form-wrapper">
              <div className="form-group">
                <label>เลขที่ใบสั่งซื้อ</label>
                <label className="order-value" style={{ color: "#ffffff !important"}}>{paymentModel.refNo}</label>
              </div>
              <div className="form-group">
                <label>ผลิตภัณฑ์</label>
                <label className="order-value">{product_name}</label>
              </div>
              <div className="form-group">
                <label>แผนประกัน</label>
                <label className="order-value">แผนที่ {plan_package}</label>
              </div>
              <div className="form-group">
                <label>ทุนประกัน</label>
                <label className="order-value">{CurrencyUtils.currency(insured)} บาท</label>
              </div>
              {/* <div className="form-group">
                <label>วันที่เดินทาง</label>
                <label className="order-value">
                {moment(start_date).format(DATETHAI_FORMAT)} - {moment(end_date).format(DATETHAI_FORMAT)}
                </label>
              </div>
              <div className="form-group">
                <label>ประเทศปลายทาง</label>
                <label className="order-value">{from + otherConcat + to}</label>
              </div> */}
            </div>
          </div>
          {/* </div> */}
          <div className="form-group successful-footer align-item-center">
            <label className="text-wrapper">
              คุณจะได้รับ {parseInt(totalAmount / 25)} AOT Point หลังจาก การซื้อประกันภายใน 15 วัน
            </label>
          </div>
          <div className="form-group footer">
            <button className="successful-btn align-item-center" onClick={() => (window.location.href = `/?confirm_pay=${paymentModel.orderId}`)}>
              ตกลง
            </button>
          </div>
        </div>
      </div>
    )
  }
}


Step6.contextType = TaContext;
export default Step6;